function notInitialized() {
  throw new Error('SoftwareVersionService is not initialized');
}

export default {
  getVersion: notInitialized,
  upgrade: notInitialized,
};



// WEBPACK FOOTER //
// ./src/scripts/application/actions/version/software_version_service.js